module.exports = __webpack_public_path__ + "static/media/bg.eb92a430.png";